import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { Menu } from "@circleco/compass/components/Menu";
import { useState } from "react";

import { t } from "@/i18n-js/instance";

import { AvatarButton } from "./AvatarButton";
import { useProfileMenuOptions } from "./useProfileMenuOptions";

export interface ProfileDropdownProps {
  isPreviewMode?: boolean;
}

export const ProfileDropdown = ({
  isPreviewMode = false,
}: ProfileDropdownProps) => {
  const { currentCommunityMember } = usePunditUserContext();
  const [isOpen, setIsOpen] = useState(false);
  const { menuOptions, isDisabled } = useProfileMenuOptions({ isPreviewMode });

  if (!currentCommunityMember) return null;

  const { avatar_url: src, name } = currentCommunityMember;

  return (
    <Menu
      align="start"
      side="top"
      options={menuOptions}
      open={isOpen}
      onOpenChange={setIsOpen}
      disabled={isDisabled}
      trigger={
        <AvatarButton
          ariaLabel={t("user_menu_options")}
          src={src}
          name={name}
          isOpen={isOpen}
          disabled={isDisabled}
          data-testid="user-profile"
        />
      }
      data-testid="user-profile-menu"
    />
  );
};
